import { participatingMemberToPlayerObject } from './participatingMemberUtils';

export const memberDetailToStandingsPlayer = (member) => {
    if (!member) {
        return null;
    }
    return participatingMemberToPlayerObject(member);
};

export const hasParticipatingMembers = (standing) => {
    return (standing?.participatingMembers ?? []).length > 0;
};
